import Page from './index'
export default {
  path: '/home/rebateRisk',

  component: Page,
}
